import { render, staticRenderFns } from "./FormClosingClaim.vue?vue&type=template&id=3cf79a3d&scoped=true"
import script from "./FormClosingClaim.vue?vue&type=script&lang=js"
export * from "./FormClosingClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf79a3d",
  null
  
)

export default component.exports